import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import {required, urls} from "../../../../core/components/forms/file/Validation";
import {PAGE_FILES} from "../../../constants/PageConstant";
import {openPage} from "../../../actions/PageActions";
import InputField from "../../../../core/components/forms/InputField";
import {fileFormSetUrls} from "../../../../core/actions/FileFormActions";
import {Trans, withTranslation} from "react-i18next";

class SimpleUrlForm extends Component {

    handleSubmit = (value) => {
        const {fileFormSetUrls} = this.props;
        const urls = value.split(/\r?\n/);

        fileFormSetUrls(urls);
        this.finish();
    };

    finish = () => {
        this.props.finishCallback();
        this.props.openPage(PAGE_FILES);
    };

    render() {
        const {handleSubmit, t} = this.props;

        return <form onSubmit={handleSubmit(values => this.handleSubmit(values.url))} className="url-frame">
            <div className="text-holder">
                <Field
                    name="url"
                    type="text"
                    component={InputField}
                    validate={[required, urls]}
                    placeholder={t('Paste URL here')}
                    autoFocus
                />
            </div>
            <button className="btn style02"><Trans>ADD</Trans></button>
        </form>
    }
}

SimpleUrlForm = withTranslation()(SimpleUrlForm);

SimpleUrlForm = reduxForm({
    form: 'UrlForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(SimpleUrlForm);

export default connect(
    state => ({}),
    dispatch => ({
        fileFormSetUrls: urls => dispatch(fileFormSetUrls(urls)),
        openPage: page => dispatch(openPage(page)),
    })
)(SimpleUrlForm);